import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const LABELS = ["Esferico", "Cilindrico", "Eixo", "Adicao", "DNP", "Altura"];
const PLACEHOLDERS = ["+0.00", "-0.00", "0", "+0.00", "mm", "mm"];

export default function EyeSection({ side, label, color, register, fields }) {
  return (
    <div className={`bg-${color}-50 border border-${color}-200 rounded-lg p-6`}>
      <h3 className={`text-lg font-semibold text-${color}-700 pb-2 mb-4`}>{side} - {label}</h3>
      <div className="grid grid-cols-2 gap-4">
        {fields.slice(0, 4).map((f, i) => (
          <div key={f} className="space-y-2">
            <Label htmlFor={f} className="text-sm font-medium text-slate-700">{LABELS[i]}</Label>
            <Input id={f} {...register(f)} placeholder={PLACEHOLDERS[i]}
              className={`font-mono text-center bg-white border-${color}-200`} data-testid={`input-${f}`} />
          </div>
        ))}
        {fields.slice(4).map((f, i) => (
          <div key={f} className="space-y-2">
            <Label htmlFor={f} className="text-sm font-medium text-slate-700">{LABELS[i + 4]}</Label>
            <Input id={f} {...register(f)} placeholder={PLACEHOLDERS[i + 4]}
              className={`font-mono bg-white border-${color}-200`} data-testid={`input-${f}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
